import { useController } from "react-hook-form";
import { FormRangePickerProps } from "./Form.types";
import FormField, { useFormField } from "./FormField/FormField";
import { DatePicker } from "antd";

export function FormRangePicker(props: FormRangePickerProps) {
  const { formFieldProps, childProps } = useFormField(props);
  const { field } = useController({ name: childProps.name });

  return (
    <FormField {...formFieldProps}>
      <DatePicker.RangePicker allowClear={false} {...childProps} {...field} />
    </FormField>
  );
}
